export abstract class Preview {
  protected _entityId: number | null = null;

  protected _limitLoad = 5;

  setEntityId(entityId: number | null): this {
    this._entityId = entityId;

    return this;
  }

  abstract fetchDataPreview(): Promise<unknown>;

  abstract fetchPartlyPreview(endPoint: string): Promise<unknown> | void;
}
